module.exports = __webpack_public_path__ + "assets/images/project/vietnamese-porcelain-desktop.jpg?v=5321210f";